import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import { Button, Carousel, Col, Layout, Row } from "antd";

import _ from "underscore";
import HomeworkDrawer from "./component/HomeworkDrawer";
import { useHistory } from "react-router-dom";
import { IGroupQuestion, IQuestion } from "../homework";
import MQuestionItem from "./component/QuestionItem";
import Countdown from "components/Countdown/countdown";
import moment from "moment";

import Style from "./mhomework.module.scss";
import { ContainerContext } from "App";
import { ExamContext } from "../Exam/ExamMain/context";
import { ExamTimeType } from "../../API";
import { BackButton } from "../../components/MHeader/Components/BackButton";

interface PageMHomeworkProps {
    data: IGroupQuestion[];
    state: number;
    type?: "homework" | "exam";
    now?: string;
    examInfo?: {
        title: string;
        endDateTime: string;
        second: number;
        examType: string;
    };
    onSubmit: () => void;
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) => void;
    onComplete?: () => void;
}

const PageMHomework: React.FC<PageMHomeworkProps> = ({
    data,
    state,
    type = "homework",
    examInfo,
    now = moment().format("YYYY-MM-DD HH:mm:ss"),
    onSubmit,
    onQuestionChange,
    onComplete
}) => {
    const { isInside } = useContext(ContainerContext);
    const history = useHistory();

    const [visible, setVisible] = useState(false);
    const [current, setCurrent] = useState(0);
    const list = useMemo(
        () =>
            _.reduce(
                data,
                (memo: IQuestion[], item: IGroupQuestion) => [
                    ...memo,
                    ...item.list
                ],
                []
            ),
        [data]
    );
    const [answeredTopics, setAnsweredTopics] = useState<number[]>([]);
    const ref = useRef<any>();

    useEffect(() => {
        const array: number[] = [];
        list.forEach(topic => {
            if (topic.topics && topic.topics.length > 0) {
                topic.topics.forEach(topic => {
                    isAnswered(topic) && array.push(topic.topicId);
                });
            } else {
                isAnswered(topic) && array.push(topic.topicId);
            }
        });
        setAnsweredTopics(array);
    }, [list]);

    function onChange(
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string,
        userAnswers?: any
    ) {
        let isAnswered = topicType === "1" || topicType === "3";

        if (typeof answerId === "object") {
            isAnswered = answerId.length !== 0;
        }

        if (topicType === "4") {
            isAnswered = isEditorAnswer(value);
        }

        if (topicType === "5") {
            isAnswered = isEditorAnswer(value);
        }

        if (!answeredTopics.includes(topicId) && isAnswered) {
            setAnsweredTopics([...answeredTopics, topicId]);
        }

        if (!isAnswered) {
            setAnsweredTopics(_.without(answeredTopics, topicId));
        }

        onQuestionChange(topicId, topicType, answerId, value, userAnswers);
    }

    function isAnswered(item: IQuestion): boolean {
        if (answeredTopics.includes(item.topicId)) return true;
        if (item.topicType === "4")
            return isEditorAnswer(item.answers[0].stuAnswer || "");
        if (item.topicType === "5")
            return _.some(item.answers, item =>
                isEditorAnswer(item.stuAnswer || "")
            );
        if (
            item.topics &&
            (item.topicType === "6" ||
                item.topicType === "7" ||
                item.topicType === "8")
        ) {
            return _.every(item.topics, topic => isAnswered(topic));
        }
        return _.some(item.answers, item => item.isChoose === "1");
    }

    function isEditorAnswer(value: string | undefined) {
        if (value === undefined) return false;
        return value !== "" && value !== "<p></p>";
    }

    const examContext = useContext(ExamContext);

    // 截止时间
    const examEndTime = useMemo(() => {
        const format = "YYYY-MM-DD HH:mm:ss";
        if (!examContext.examSettings || !examContext.examSettings.stuStartTime)
            return null;
        if (examContext.examSettings.timeType !== ExamTimeType.Free)
            return examContext.examSettings.endTime; // 非自主时间考试, 统一按截止日期算
        return moment(examContext.examSettings.stuStartTime)
            .add(examContext.examSettings.duration, "minutes")
            .format(format); // 已开始的自主考试, 截止日期为开始考试时间+考试时间
    }, [examContext.examSettings]);

    return (
        <Layout className={Style.root}>
            {!(isInside && type === "homework") && (
                <Layout.Header className={Style.header}>
                    <Row type="flex" justify="space-between">
                        {type === "homework" && (
                            <Col span={6}>
                                <BackButton className={Style.NavBtn} />
                            </Col>
                        )}
                        {type === "exam" && examInfo?.examType === "2" && (
                            <Col span={6}>
                                <BackButton className={Style.NavBtn} />
                            </Col>
                        )}
                        {type === "exam" && examInfo?.examType !== "2" && (
                            <Col span={6}>
                                {examEndTime ? (
                                    <Countdown
                                        now={now}
                                        onComplete={onComplete!}
                                        endDateTime={examEndTime}
                                    />
                                ) : (
                                    "倒计时生成中"
                                )}
                            </Col>
                        )}
                        <Col span={12} className={Style.title}>
                            {type === "homework" ? "作业" : "考试"}
                        </Col>
                        {list.length > 1 ? (
                            <Col span={6}>
                                <Button
                                    type="link"
                                    className={Style.NavBtn}
                                    onClick={() => setVisible(true)}>
                                    答题卡
                                </Button>
                            </Col>
                        ) : (
                            <Col span={6} />
                        )}
                    </Row>
                </Layout.Header>
            )}

            <Layout.Content className={Style.Content}>
                {type === "exam" && examInfo!.examType === "2" && (
                    <div>
                        <Row className={Style.endDateTime}>
                            <Col>{examInfo!.title}</Col>
                        </Row>
                        <Row
                            className={Style.endDateTime}
                            type="flex"
                            justify="space-between">
                            <Col>截止时间</Col>
                            <Col>{examInfo!.endDateTime}</Col>
                        </Row>
                    </div>
                )}
                <Carousel
                    infinite={false}
                    ref={ref}
                    afterChange={setCurrent}
                    dots={false}>
                    {list.map((item, index) => (
                        <MQuestionItem
                            canPastedText={type !== "exam"}
                            showHeader={
                                examInfo ? examInfo.examType !== "2" : true
                            }
                            key={item.topicId}
                            index={index}
                            data={item}
                            state={state}
                            empty={index > current + 1 || index < current - 1}
                            onQuestionChange={onChange}
                        />
                    ))}
                </Carousel>
            </Layout.Content>

            <Layout.Footer className={Style.footer}>
                <Row type="flex" justify={"space-around"}>
                    {list.length > 1 && (
                        <Col>
                            <Button
                                onClick={() => ref.current.prev()}
                                disabled={current === 0}>
                                上一题
                            </Button>
                        </Col>
                    )}
                    {list.length > 1 && isInside && (
                        <Col>
                            <Button
                                onClick={() => setVisible(true)}
                                type="primary">
                                答题卡
                            </Button>
                        </Col>
                    )}
                    {state === 1 && (
                        <Col>
                            {" "}
                            <Button
                                type="primary"
                                onClick={onSubmit}
                                className={Style.submit}>
                                {type === "exam" ? "交卷" : "提交"}
                            </Button>
                        </Col>
                    )}
                    {list.length > 1 && (
                        <Col>
                            <Button
                                onClick={() => ref.current.next()}
                                disabled={current === list.length - 1}>
                                下一题
                            </Button>
                        </Col>
                    )}
                </Row>
            </Layout.Footer>

            <HomeworkDrawer
                visible={visible}
                data={list}
                answeredTopics={answeredTopics}
                onClose={() => setVisible(false)}
                onClick={index => ref.current.goTo(index)}
            />
        </Layout>
    );
};

export default PageMHomework;
